import { render, staticRenderFns } from "./BranchtoTeller.vue?vue&type=template&id=9488ed64&scoped=true"
import script from "./BranchtoTeller.vue?vue&type=script&lang=js"
export * from "./BranchtoTeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9488ed64",
  null
  
)

export default component.exports